import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ZodFormProvider } from './context.js';
import { defaultWidgets } from './widgets/registry.js';
import { pruneUntouchedSecrets } from './lib/prune-untouched-secrets.js';
export function ZodForm(props) {
    const { schema, defaultValues, onSubmit, onServerError, fieldMetaOverrides = {}, readonly = false, widgets = defaultWidgets, children, className, id, pruneSecrets = true, } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const useFormOpts = {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolver: zodResolver(schema),
        mode: 'onSubmit',
        reValidateMode: 'onChange',
    };
    if (defaultValues !== undefined)
        useFormOpts.defaultValues = defaultValues;
    const form = useForm(useFormOpts);
    const handleSubmit = form.handleSubmit(async (values) => {
        try {
            const prepared = pruneSecrets
                ? pruneUntouchedSecrets(values, form.formState.dirtyFields, schema)
                : values;
            await onSubmit(prepared, form);
        }
        catch (err) {
            if (onServerError)
                onServerError(err, form);
            else
                throw err;
        }
    });
    return (_jsx(FormProvider, { ...form, children: _jsx(ZodFormProvider, { value: {
                form,
                schema,
                readonly,
                fieldMetaOverrides,
                widgets,
            }, children: _jsx("form", { id: id, onSubmit: handleSubmit, className: className ?? 'flex flex-col gap-4', noValidate: true, children: children }) }) }));
}
//# sourceMappingURL=zod-form.js.map